import React, { memo, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';

const AvatarRenderer = ({ src, alt = '-', style = {} }) => {
  const classes = useStyles();
  const [error, setError] = useState(false);

  return (
    <>
      <Avatar
        src={src}
        alt={alt}
        imgProps={{ onError: () => setError(true), onLoad: () => setError(false) }}
        className={clsx(classes.img, { [classes.logo]: error })}
        style={{ height: 70, width: 70, ...style }}
      />
    </>
  );
};

export default memo(AvatarRenderer);

const useStyles = makeStyles(() => ({
  img: {
    '& .MuiAvatar-img': { objectFit: 'contain' },
    '&.MuiAvatar-root': { borderRadius: 1 },
  },
  logo: { visibility: 'hidden' },
}));
